(function initSensitiveContent() {
  /**
   * @param {MouseEvent} event
   */
  function handleSensitiveToggle(event) {
    const target = event.target instanceof Element ? event.target : null;
    const toggleBtn = target ? target.closest('[data-sensitive-toggle]') : null;
    if (!toggleBtn) return;

    event.preventDefault();
    event.stopPropagation();

    const container = toggleBtn.closest('.has-sensitive-content, [data-sensitive-container]');
    if (!container) return;

    const isCurrentlyRevealed = container.classList.contains('sensitive-revealed');
    const newRevealedState = !isCurrentlyRevealed;

    // Pobranie ID produktu
    const productId = container.dataset.productId ||
      container.getAttribute('data-sensitive-product-id') ||
      toggleBtn.dataset.productId;

    if (productId) {
      // Spójny selektor uwzględniający wszystkie warianty kontenerów
      const selector = [
        `[data-product-id="${productId}"]`,
        `[data-sensitive-product-id="${productId}"]`
      ].flatMap(attr => [
        `${attr}.has-sensitive-content`,
        `${attr}[data-sensitive-container]`,
        `.media-gallery${attr}`
      ]).join(', ');

      document.querySelectorAll(selector).forEach((el) => {
        el.classList.toggle('sensitive-revealed', newRevealedState);
      });
    } else {
      container.classList.toggle('sensitive-revealed', newRevealedState);
    }

    // Aktualizacja dostępności (A11y)
    toggleBtn.setAttribute('aria-expanded', String(newRevealedState));
  }

  document.addEventListener('click', handleSensitiveToggle, true);
})();